import UrlTypes from '@/enums/UrlTypes';

/**
 * IO provider URL classification.
 */
export function classifyIoUrl(loc: string): UrlTypes {
    const normalizedLoc = loc.toLowerCase().trim();

    // Static assets => OTHER
    if (
        normalizedLoc.includes('wp-content') ||
        normalizedLoc.includes('json') ||
        normalizedLoc.includes('uploads') ||
        normalizedLoc.endsWith('.css') ||
        normalizedLoc.includes('io_') ||
        normalizedLoc.includes('xmlrpc.php')
    ) {
        return UrlTypes.OTHER;
    }

    // Normalize pathname
    let pathname = normalizedLoc;
    if (normalizedLoc.startsWith('http')) {
        try {
            pathname = new URL(normalizedLoc).pathname.toLowerCase();
        } catch {
            pathname = normalizedLoc;
        }
    }
    if (!pathname || pathname === '') {
        pathname = '/';
    }

    // Homepage
    if (pathname === '/') {
        return UrlTypes.OTHER;
    }

    // Rentals hierarchy
    if (pathname.startsWith('/rentals/') || pathname.startsWith('/inventory/')) {
        const segments = pathname.split('/').filter(Boolean);
        if (segments.length === 1) {
            return UrlTypes.CATEGORY_HUB;
        }
        if (segments.length === 2) {
            return UrlTypes.CATEGORY;
        }
        return UrlTypes.PRODUCT;
    }

    // Everything else is a standard page
    return UrlTypes.UNCLASSIFIED;
}
